export default {
  "AgreementModal.CloseButton": "閉じる",
}
